import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

import { getAppConfig } from '@config/get-app-config';
import { REALM } from '@utilities/constants';

const CDN_BASE = 'https://cdn.public.zooplus.net/media/ui-components/v7-latest/fonts';

const REALM_FONTS: Record<string, string[]> = {
  [REALM.ZOOPLUS]: [
    `${CDN_BASE}/nunito-cyrillic_latin-regular.woff2`,
    `${CDN_BASE}/nunito-cyrillic_latin-700.woff2`,
    `${CDN_BASE}/nunito-cyrillic_latin-900.woff2`,
  ],
  [REALM.BITIBA]: [`${CDN_BASE}/roboto-slab-latin-700.woff2`],
};

const PageThemeContainer = ({ children }: { children: ReactNode }) => {
  const {
    site: { realm = REALM.ZOOPLUS },
  } = getAppConfig();
  const fonts = REALM_FONTS[realm] ?? REALM_FONTS[REALM.ZOOPLUS];

  return (
    <>
      <Helmet>
        <body className={`z-brand-theme-2026spring-${realm}`} />
        {fonts.map((href) => (
          <link
            key={href}
            rel="preload"
            href={href}
            as="font"
            type="font/woff2"
            crossOrigin="anonymous"
          />
        ))}
      </Helmet>
      {children}
    </>
  );
};

export default PageThemeContainer;
